module.exports = __webpack_public_path__ + "static/media/museum.004e8c34.svg";